module.exports = __webpack_public_path__ + "img/home-1.5e74bef8.webp";